<template>
  <div class="cont_body">
    <div class="list_cont">
      <div class="list_img">
        <img :src="getImg(optionsData.picture)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{optionsData.projectName}}</h4>
        <div class="list_cont_mid">
          <p><span v-for="(item,key) in optionsData.projectField.split()" :key="key">
            <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item"></dict-render>
          </span>
            </p>
        </div>
      </div>
      <div class="list_botton">
        <a-button v-if="dockingType" size="large" @click="onAdd" style="width:120px;" >投递BP</a-button>
        <a-button size="large" style="width:120px;background: #ffffff;color:#1890ff;border:1px solid #1890ff;margin-top:10px;position:relative" >
          商业计划书</a-button>
          <div style="left:0;bottom:0;padding:9px 0; width:118px;overflow:hidden;position:absolute;opacity: 0;">
            <file-upload v-model:value="optionsData.businessPlan" />
          </div>
      </div>
    </div>
    <div class="list_bottom">
      <h4>投资机构简介</h4>
      <p v-html="optionsData.projectOverview">
        
      </p>
    </div>
  </div>
  <a-modal width="600px" title="投递BP" v-model:visible="visible" :maskClosable="false" :closable="false"  @ok="onSubmit" @cancel="handleCancel">
    <a-form :labelCol="{span:6}" layout="horizontal" ref="ruleForm" :model="form" :rules="rules" @submit="onSubmit">
        <a-row :gutter="[24,8]">
          <a-col :span="24">
              <div class="hidden">
                  <a-form-item label="当前id" name="senderId">
                      <a-input v-model:value="form.senderId" placeholder="请输入当前id" />
                  </a-form-item>
                  <a-form-item label="本条id" name="receiverId">
                      <a-input v-model:value="form.receiverId" placeholder="请输入本条id" />
                  </a-form-item>
                  <a-form-item label="对接类型" name="dockingType">
                    <a-input v-model:value="form.dockingType" placeholder="请输入对接类型" />
                </a-form-item>
              </div>
              <a-form-item :labelCol='{span:4}' label="联系人姓名" name="senderContact">
                  <a-input v-model:value="form.senderContact" placeholder="请输入联系人姓名" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="联系人电话" name="contactNumber">
                  <a-input v-model:value="form.contactNumber" placeholder="请输入联系人电话" />
              </a-form-item>
              <a-form-item :labelCol='{span:4}' label="对接备注" name="content">
                  <a-textarea v-model:value="form.content" placeholder="请输入对接备注"
                            :auto-size="{ minRows: 5, maxRows: 6 }" />
              </a-form-item>
          </a-col>
        </a-row>
    </a-form>
</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { dictMixin,formMixin } from "@/mixins";
import {financeProjectWeb,financeDocking} from "@/api/finance";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin,formMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dictNames: 'investmentField',
      optionsData:null,
      visible:false,
      role: null,
      form: {
          projectId: null,
          senderId: null,
          receiverId: null,
          dockingType: null,
          senderContact: null,
          contactNumber: null,
          content: null,
          processingState: null,
      },
      rules: {
          projectId: [dataCheck.required({})],
          senderId: [],
          receiverId: [],
          dockingType: [],
          senderContact: [dataCheck.required({})],
          contactNumber: [dataCheck.required({})],
          processingState: [dataCheck.required({})],
          content: [],
      },
    }
  },
  computed: {
      submitUrl() {
          return financeDocking.add
      }
  },
  created(){
    if(this.$route.query.queryData){
      this.getAction({
          url: financeProjectWeb.detail,
          params: {
            id:this.$route.query.queryData
          }
      }).then(res => {
        this.optionsData = res
        this.form.receiverId = res.id
        this.form.senderId = this.$ls.get('notificationId')
        this.role = this.$ls.get('roleCode').split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          this.dockingType = null
          }
          if(item=='investorManager'){
            this.dockingType = '1'
          }else if(item=='investmentMechanism'){
            this.dockingType = '3'
          }else{
            this.dockingType = null
          }

        })
      })
     
      
    }
  },
	methods: {
    onAdd() {
            this.form.senderContact=null,
            this.form.contactNumber=null,
            this.form.content=null,
            this.visible=true;
    },
    handleOk(){
            this.visible = false;
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 100%;
  margin-bottom: 16px;
  &:hover{
    cursor: auto!important;
    box-shadow: none!important;
  }
  .list_img{
    width: 100px;
    height: 100px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    height:130px;
    flex: 6;
    h4{
      line-height: 50px;
    }
    .list_cont_mid{
      overflow: auto;
      padding-right:30%;
      color:#9c9c9c;
      p{
        display: block;
        float: left;
        width: 50%;
      }
    }
    .list_cont_end{
      margin-top: 20px;
      clear: both;
    }
  }
  .list_botton{
    position: relative;
    flex: 1;
    :deep(.ant-btn){
      font-size: 14px;
      background: #1890ff;
      color:#fff;
      border:none
    }
  }
}
.list_bottom{
  h4{
    color:#1890ff;
    font-weight: 600;
    font-size: 22px;
    margin-bottom: 10px;
  }
  p{
    line-height: 25px;
  }
}
</style>